import { Map } from "immutable"

import { getList } from "./utils/entity-network-requests"

export function autocomplete(token, searchTerm, ...entityTypes) {
    const parameters = Map({
        [entityTypes[0] === "PermissionGroup" ? "id" : "name"]: searchTerm,
        ...entityTypes.reduce((typeParameters, type) => {
            if (typeof type === "string" || type instanceof String) {
                typeParameters[type] = true
                return typeParameters
            } else {
                return {
                    ...typeParameters,
                    ...type
                }
            }
        }, {})
    })
    return getList("autocomplete", parameters, token)
}
